<template>
<v-tabs centered color="primary" dark mandatory icons-and-text v-model="active">
  <v-tabs-slider color="yellow" />

  <v-tab href="#tab-1">
    {{ $vuetify.t('$vuetify.account.membership') }}
    <!-- {{ membershipTitle }} -->
    <v-icon>account_circle</v-icon>
  </v-tab>

  <v-tab href="#tab-2">
    {{ $vuetify.t('$vuetify.account.history') }}
    <v-icon>history</v-icon>
  </v-tab>

  <v-tab href="#tab-3">
    {{ $vuetify.t('$vuetify.account.payments') }}
    <v-icon>payment</v-icon>
  </v-tab>


  <v-tab-item v-if="active == 'tab-1'" :value="'tab-1'">
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <account-details />
      </v-flex>
    </v-layout>
  </v-tab-item>

  <v-tab-item v-if="active == 'tab-2'" :value="'tab-2'">
    <v-layout row wrap>
      <v-flex style="margin-left: 24px; margin-right: 24px;">
        <order-history-list/>
      </v-flex>
    </v-layout>
  </v-tab-item>

  <v-tab-item v-if="active == 'tab-3'" :value="'tab-3'">
    <v-btn color="primary" flat outline :block="$vuetify.breakpoint.smAndDown"
            @click="setAddPaymentMethodDialog(true)"
    >
      {{ $vuetify.t('$vuetify.account.addPaymentMethod') }}
    </v-btn>

    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <payment-method-list/>
      </v-flex>
    </v-layout>
  </v-tab-item>
</v-tabs>
</template>

<script>
  import OrderHistoryList from '@/components/Account/OrderHistoryList'
  import PaymentMethodList from '@/components/Account/PaymentMethodList'
  import AccountDetails from '@/components/Account/AccountDetails'

  import { mapGetters, mapActions } from 'vuex'
  import get from 'lodash/get';


  import { matchTranslation } from "@/services/util.service"

  export default {
    components: {
      OrderHistoryList,
      PaymentMethodList,
      AccountDetails
    },

    watch: {
      '$route'(to, from) {
        this.active = this.$route.query.tab || 'tab-1'
      }
    },

    data() {
      return {
        active: this.$route.query.tab || 'tab-1'
      }
    },

    computed: {
      membershipTitle() {
        const _customName = get(this.getStore, 'settings.membershipSettings.customMembershipName')

        if (!!_customName) {
          const _translation = matchTranslation(_customName.translations)

          if (!!_translation)
            return _translation;
        }

        return this.$vuetify.t('$vuetify.common.balance')
      },

      ...mapGetters([ 'getStore' ])
    },

    methods: {
      ...mapActions([ 'setAddPaymentMethodDialog' ])
    },

    created() {
      /**
       * Reset order history because the page index will become stale
       * as soon as there are new orders.
       */
      this.$store.commit('RESET_ORDER_HISTORY_PAGE')
      this.$store.dispatch('fetchOrderHistoryPage')
      this.$store.dispatch('fetchPaymentMethods')

       const temp = this.active
       // The first one needed a different number to be update properly
       this.active = this.active == 'tab-1' ? 'tab-2' : 'tab-1'

       this.$nextTick(() => {
         setTimeout(() => {
           this.active = temp
         }, 200)
       })
    }
  }
</script>
